import React from "react";
import "./SkillsIcon.css"

const SkillsIcon = (props) => {
    return(
        <div className="skillsIcon">
            <img src={props.img} alt="" />
            <p>{props.text}</p>
        </div>
    )
}

export default SkillsIcon